import { Auth, Storage } from "aws-amplify";
import _ from "lodash";
import { API } from "aws-amplify";

export class hpUser {
  constructor() {}

  getAvatarImage(key) {
    return new Promise((resolve, reject) => {
      Storage.get(key, {
        level: "public"
      }).then(result => {
        resolve(result);
      });
    });
  }

  async getUsers() {
    let that = this;
    return new Promise(function(resolve, reject) {
      API.get("hpManageUserApi", "/users/listUsers/").then(cognitoUsers => {
        const users = _.orderBy(cognitoUsers.users, "firstName", "asc");
        users.forEach(function(user, index) {
          if (user.s3avatar) {
            that.getAvatarImage(user.s3avatar).then(result => {
              users[index].s3avatarUrl = result;
            });
          }
        });
        return resolve(users);
      });
    });
  }

  async getUserByUsername(username) {
    return new Promise(function(resolve, reject) {
      API.get("hpManageUserApi", "/users/getgroupbyusername", {
        queryStringParameters: {
          'email': username
        }
      }).then((cognitoUser) => {
        return resolve(cognitoUser.users);
      });
    });
  }

  async getAwsCognitoGroups() {
    return new Promise(function(resolve, reject) {
      API.get("hpManageUserApi", "/users/listgroups/").then(cognitoGroups => {
        return resolve(cognitoGroups.groups);
      });
    });
  }

  async createAwsCognitoUser(form) {
    return new Promise(function(resolve, reject) {
      const body = {
        form
      };
      API.post("hpManageUserApi", "/users/createuser/", { body }).then((result) => {
        return resolve(result.msg);
        }
      );
    });
  }

  async deleteAwsCognitoUser(username) {
    return new Promise(function(resolve, reject) {
      API.get("hpManageUserApi", "/users/deletecognitouser/", {
        'queryStringParameters': {
          'username': username
        }
      }).then((result) => {
        return resolve(result.msg);
      });
    });
  }

  async updateAwsCognitoUserAttributes(addRoles, removeRoles, form) {
    return new Promise(function(resolve, reject) {
      const body = {
        addRoles, removeRoles, form,
      };
      API.put("hpManageUserApi", "/users/updateCognitoUserAttributes/", {
        body
      }).then(result => {
        return resolve(result.msg);
      });
    });
  }

  async resetAwsCognitoPassword(username) {
    return new Promise(function(resolve, reject) {
      API.get("hpManageUserApi", "/users/resetuserpassword/", {
        'queryStringParameters': {
          'username': username
        }
      }).then((result) => {
        return resolve(result.msg);
      });
    });
  }

  async disableUser(username) {
    return new Promise(function(resolve, reject) {
      API.get("hpManageUserApi", "/users/disablecognitouser/", {
        'queryStringParameters': {
          'username': username
        }
      }).then((result) => {
        return resolve(result.msg);
      });
    });
  }

  async enableUser(username) {
    return new Promise(function(resolve, reject) {
      API.get("hpManageUserApi", "/users/enablecognitouser/", {
        'queryStringParameters': {
          username: username
        }
      }).then((result) => {
        return resolve(result.msg);
      });
    });
  }

  async updateAwsCognitoUserRoles(addRoles, removeRoles, username) {
    const body = {
      addRoles, removeRoles, username,
    };
    return new Promise(function(resolve, reject) {
      API.put("hpManageUserApi", "/users/updatecognitouserroles/", { body }).then((result) => {
        return resolve(result.msg);
      });
    });
  }

  async getUserRoles() {
    return new Promise(function(resolve, reject) {
      Auth.currentAuthenticatedUser().then((user) => {
        const awsGroups =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        if (awsGroups) {
          const roles =
            user.signInUserSession.accessToken.payload["cognito:groups"];
          resolve(roles);
        }
      });
    });
  }
}
